<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <component-header
          title="Edit FAQ"
          :hasSearch="false"
          :hasCreate="false"
          :hasReload="false"
          :hasback="true"
          @back-press="$router.push({ name: 'Faqs' })"
        />
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col md="12">
        <b-card>
          <b-row class="font-md" v-if="userRole === 'Tenant'">
            <b-col md="4">
              <span>Scope</span>
            </b-col>
            <b-col md="8">
              <div class="form-group">
                <b-form-select
                  id="type"
                  v-model="faqData.scope"
                  :options="scopeOptions"
                  placeholder="Scope"
                ></b-form-select>
              </div>
            </b-col>
          </b-row>
          <b-row class="font-md">
            <b-col md="4">
              <span>Category</span>
            </b-col>
            <b-col md="8">
              <div class="form-group">
                <b-form-select
                  id="type"
                  v-model="faqData.category"
                  :options="categoryOptions"
                  placeholder="Category Type"
                ></b-form-select>
              </div>
            </b-col>
          </b-row>
          <b-row class="font-md">
            <b-col md="4">
              <span>Topic</span>
            </b-col>
            <b-col md="8">
              <div class="form-group">
                <input class="form-control" v-model="faqData.Topic" />
              </div>
            </b-col>
          </b-row>
          <b-row class="font-md">
            <b-col md="4">
              <span>Description</span>
            </b-col>
            <b-col md="8">
              <div class="form-group">
                <input class="form-control" v-model="faqData.Description" />
              </div>
            </b-col>
          </b-row>
          <b-row class="font-md">
            <b-col md="4">
              <span>Media Type</span>
            </b-col>
            <b-col md="8">
              <div class="form-group">
                <eb-select
                  id="type"
                  v-model="faqData.mediaType"
                  :selected="faqData.mediaType"
                  :options="mediaOptions"
                  @select="onSelect"
                  placeholder="Media Type"
                ></eb-select>
              </div>
            </b-col>
          </b-row>
          <b-row class="font-md">
            <b-col md="4">
              <span>Media Content</span>
            </b-col>
            <b-col md="8">
              <div class="mb-3">
                <eb-button
                  classic="mr-1 btn-primary"
                  text="Download Content"
                  @click="downloadFile"
                ></eb-button>
              </div>
            </b-col>
          </b-row>
          <b-row class="font-md">
            <b-col md="4">
              <span>Update Media</span>
            </b-col>
            <b-col md="7">
              <div class="form-group">
                <b-form-file
                  @change="changemedia"
                  :state="Boolean()"
                  :accept="uploadFileType"
                  placeholder="Update Media Here..."
                  drop-placeholder="Drop Media here..."
                ></b-form-file>
              </div>
            </b-col>
            <b-col md="1" v-if="showLoader">
              <div class="spinner-border text-primary" role="status"></div>
            </b-col>
          </b-row>
          <span v-if="invalidFile" class="validate-error"
              >Invalid File format</span>
            <div class="text-center mt-3 mb-3">
              <eb-button
                class="btn mr-4"
                classic="mr-1 btn-primary"
                text="Update"
                :disabled="invalidFile || showLoader"
                @click.prevent="handleSubmit"
              ></eb-button>
            </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import cInput from "@/components/Common/CustomInput";
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import faqdetails from "@/components/MasterSetup/FAQ/FAQDetails.vue";
import ComponentHeader from "@/components/componentNewHeader";
import { mapState } from "vuex";
export default {
  name: "editfaq",
  components: {
    ebButton,
    cInput,
    ebSelect,
    faqdetails,
    ComponentHeader,
  },
  data: () => {
    return {
      show: true,
      mediaOptions: ["VIDEO", "IMAGE", "DOCUMENT"],
      categoryOptions: ["Order", "Payment"],
      scopeOptions: ["PARTNER", "CUSTOMER"],
      mediaType: "",
      selected: "",
      photo: "",
      scope: "",
      id: "",
      category: "",
      topic: "",
      description: "",
      invalidFile: false,
      showLoader: false,
    };
  },
  // props: {
  //   faqData: {
  //     type: Object,
  //     required: true,
  //   },
  // },
  computed: {
    ...mapState({
      faqData: (state) => state.faq.faqData,
    }),
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
    uploadFileType() {
      if (this.faqData.mediaType == "IMAGE") return "image/*";
      if (this.faqData.mediaType == "VIDEO") return "video/*";
      return "text/*,application/*";
    },
  },
  watch:{
    mediaType(newval, oldval) {
      if (newval != oldval) {
        if (this.photo != "") this.invalidFile = true;
        this.photo = "";
      }
    },
  },
  methods: {
    downloadFile() {
      window.open(this.faqData.mediaContent);
    },
    onSelect() {
      if (this.faqData.mediaType == "image") {
        show = "false";
      }
    },
    async uploadFile(file) {
      this.$toasted.info("Uploading...");
      this.showLoader = true;
      if (this.faqData.mediaType !== "IMAGE") {
        await this.$store
          .dispatch("inventory/uploadVideoToStorage", file)
          .then((res) => {
            this.photo = res.data.fileUrl;
          })
          .catch((error) => {
            this.$swal({
              type: "error",
              text: "File Upload failed! please try again.",
            });
          });
        this.$toasted.success("Upload Complete");
      } else {
        let dataobj = {
          image: file,
          key: (
            Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
          ).toLowerCase(),
          isPublic: true,
          replaceExisting: true,
          basePath: "faq",
        };
        await this.$store
          .dispatch("inventory/uploadImageToStorage", dataobj)
          .then((res) => {
            this.photo = res.data.fileUrl;
          })
          .catch((error) => {
            this.$swal({
              type: "error",
              text: "File Upload failed! please try again.",
            });
          });
        this.$toasted.success("Upload Complete");
      }
      this.showLoader = false;
    },
    changemedia(e) {
      if (
        this.faqData.mediaType == "IMAGE" &&
        !e.target.files[0].type.match("image.*")
      ) {
        this.invalidFile = true;
        e.target.value = "";
        return;
      }
      if (
        this.faqData.mediaType == "VIDEO" &&
        !e.target.files[0].type.match("video.*")
      ) {
        this.invalidFile = true;
        e.target.value = "";
        return;
      }
      if (
        this.faqData.mediaType == "DOCUMENT" &&
        !(
          e.target.files[0].type.match("application.*") ||
          e.target.files[0].type.match("text.*")
        )
      ) {
        this.invalidFile = true;
        e.target.value = "";
        return;
      }
      this.invalidFile = false;
      if (this.faqData.mediaType !== "IMAGE") {
        if (e.target.files.length != 0) {
          const formData = new FormData();
          formData.append("file", e.target.files[0]);
          formData.append("isPublic", "true");
          formData.append("replaceExisting", "true");
          formData.append("basePath", "faq");
          formData.append(
            "key",
            (
              Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
            ).toLowerCase()
          );
          this.uploadFile(formData);
        }
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = () => {
          this.uploadFile(reader.result);
          //this.$emit("readIMG", this.img);
        };
        reader.onerror = (err) => {
          console.error("reader : ", err);
        };
      }
    },
    async handleSubmit() {
      let dataObj;
      if (
        JSON.parse(sessionStorage.getItem("userLogin"))["role"] === "Tenant"
      ) {
        dataObj = {
          id: this.faqData._id + "/" + this.faqData.item_id,
          data: {
            tenant: this.$store.getters["auth/getUserID"],
            category: this.faqData.category,
            scope: this.faqData.scope,
            item: {
              topic: this.faqData.Topic,
              description: this.faqData.Description,
              media: {
                mediaType: this.faqData.mediaType,
                mediaContent: this.photo,
              },
            },
          },
        };
      } else {
        dataObj = {
          id: this.faqData._id + "/" + this.faqData.item_id,
          data: {
            category: this.faqData.category,
            scope: "TENANT",
            item: {
              topic: this.faqData.Topic,
              description: this.faqData.Description,
              media: {
                mediaType: this.faqData.mediaType,
                mediaContent: this.photo,
              },
            },
          },
        };
      }
      await this.$store.dispatch("faq/updateFaq", dataObj).then(() => {
        this.$swal({
          title: "Success",
          text: "Faq updated successfully!!",
          type: "success",
        });
      });
      this.$router.push({ name: "Faqs" });
    },
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
</style>
